/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

jQuery(document).ready(function () {
  storeLocatorIcons();

  jQuery('.mobile-nav__item--sub').on('click', (e) => {
    let nav = jQuery('.mobile-nav__item--sub');

    nav.not(e.currentTarget).children().each(function () {
      jQuery(this).removeClass('js-active');
    })
  });

  const productCarousel = jQuery('.category__product_carousel');

  if (productCarousel.length) {
    jQuery('.category__product_carousel').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      arrows: true,
      dots: true,
      cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
      prevArrow: '<button class="category__slider_button category__slider_prev_arrow"></button>',
      nextArrow: '<button class="category__slider_button category__slider_next_arrow"></button>',
      responsive: [
        {
          breakpoint: 1281,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 414,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          }
        },
      ]
    });
  }

  var productsInSlider = jQuery(".section--products_slider .section--products_slider_inner .products_slider .products_slider__item").length;
  var productSlider = jQuery(".section--products_slider .section--products_slider_inner .products_slider");

  if (productSlider) {
    jQuery(".section--products_slider .section--products_slider_inner .products_slider").slick({
        infinite: true,
        slidesToShow: Math.min(5, productsInSlider - 1),
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: '<button class="category__slider_button category__slider_prev_arrow"></button>',
        nextArrow: '<button class="category__slider_button category__slider_next_arrow"></button>',
        centerMode: true,
        variableWidth: true,
        cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
        responsive: [{
            breakpoint: 1600,
            settings: {
                slidesToShow: Math.min(5, productsInSlider - 1),
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1440,
            settings: {
                slidesToShow: Math.min(4, productsInSlider - 1),
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: Math.min(3, productsInSlider - 1),
                slidesToScroll: 1
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: Math.min(2, productsInSlider - 1),
                slidesToScroll: 1
            }
        }, {
            breakpoint: 479,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
  }

  if (jQuery(window).width() < 992 && jQuery(".headlines_with_images_content").length > 0) {
    jQuery(document).on("click", ".headlines_with_images_content .headline_heading", function () {
      if (jQuery(this).next().is(":hidden")) {
        jQuery(this).next().slideDown({
          start: function () {
            jQuery(this).css({
              display: "flex"
            })
          }
        });
        jQuery(this).parent().addClass("active");
      } else {
        jQuery(this).next().slideUp();
        jQuery(this).parent().removeClass("active");
      }
    });
  }
})

jQuery(window).on("resize", function () {
  storeLocatorIcons();
})

function storeLocatorIcons() {

  const iconsBanner = jQuery(".IconsBanner__wrapper");

  if (iconsBanner.length) {
    if (jQuery(window).width() < 768) {
      if (!iconsBanner.hasClass("slick-initialized")) {
        jQuery(".IconsBanner__wrapper").slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          autoplay: false,
          dots: true,
          arrows: false,
          cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
          responsive: [ {
            breakpoint: 575,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
            {
              breakpoint: 414,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
          ]
        });
      }
    } else {
      if (iconsBanner.hasClass("slick-initialized")) {
        jQuery(".IconsBanner__wrapper").slick('unslick');
      }
    }
  }

  const sectionProductList = jQuery(".section--products_list .products_list");

  if (sectionProductList.length) {

    if (jQuery(window).width() < 992) {
      if (!sectionProductList.hasClass("slick-initialized")) {
        jQuery(".section--products_list .products_list").slick({
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          arrows: false,
          cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
          responsive: [ {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          } ]
        });
      }
    } else {
      if (sectionProductList.hasClass("slick-initialized")) {
        jQuery(".section--products_list .products_list").slick('unslick');
      }
    }
  }

  const featureProductList = jQuery(".feature_product_list");

  if (featureProductList.length) {
    if (jQuery(window).width() < 1200) {
      if (!featureProductList.hasClass("slick-initialized")) {
        jQuery(".feature_product_list").slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          arrows: false,
          cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
          responsive: [ {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 641,
            settings: {
              centerMode: true,
              centerPadding: '38px',
              slidesToShow: 1,
              slidesToScroll: 1
            }
          } ]
        });
      }
    } else {
      if (featureProductList.hasClass("slick-initialized")) {
        jQuery(".feature_product_list").slick('unslick');
      }
    }
  }

  const promoBlocks = jQuery(".promo_blocks_inner .promo_blocks");

  if (promoBlocks.length) {
    if (jQuery(window).width() < 992) {
      if (!promoBlocks.hasClass("slick-initialized")) {
        jQuery(".promo_blocks_inner .promo_blocks").slick({
          infinite: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          arrows: false,
          cssEase: 'cubic-bezier(0.23, 1, 0.32, 1)',
          responsive: [ {
            breakpoint: 641,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '30px',
            }
          } ]
        });
      }
    } else {
      if (promoBlocks.hasClass("slick-initialized")) {
        jQuery(".promo_blocks_inner .promo_blocks").slick('unslick');
      }
    }
  }
}
